<form [formGroup]="form">
  <p-toolbar styleClass="contextbar">
    <div class="p-toolbar-group-left">
      <div class="p-inputgroup inline">
        <label for="site" class="p-inputgroup-addon">Site</label>
        <p-dropdown
          [options]="sites | async"
          formControlName="siteId"
          name="site"
          inputId="site"
          [filter]="true"
          filterBy="label"
          [resetFilterOnHide]="true"
        ></p-dropdown>
      </div>

      <i class="pi pi-bars"></i>

      <div class="p-inputgroup inline">
        <label for="date" class="p-inputgroup-addon">Date</label>
        <lib-worked-calendar
          formControlName="date"
          [siteId]="siteId | async"
          inputId="date"
          name="date"
          ngDefaultControl
          [allowEmptyDates]="true">
        </lib-worked-calendar>
        <button pButton class="p-button-nonbutton" type="button" icon="pi pi-chevron-right" (click)="ChangeToToday()" title="Go to Today"></button>
      </div>

      <i class="pi pi-bars"></i>

      <div class="p-inputgroup inline" *ngIf="!(isTpm | async)">
        <label for="shift" class="p-inputgroup-addon">Shift</label>
        <p-dropdown [options]="shifts | async" formControlName="shiftId" name="shift" inputId="shift"></p-dropdown>
      </div>

      <div *ngIf="!(workedShiftStatus | async)" style="display: inline-flex">
        <p-message class="shift-status-msg" severity="info" text="{{shiftDesc | async}} is unopened." closable="false"></p-message>
        <button pButton
          class="p-button-secondary"
          style="margin-left: 10px"
          label="Open&nbsp;Shift"
          [icon]="openingShift ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"
          [disabled]="openingShift"
          (click)="showOpenDialog = true">
        </button>
      </div>

      <div *ngIf="(workedShiftStatus | async) === ShiftStatus.Closed" style="display: inline-flex; align-items: center;">
        <p-message class="shift-status-msg" severity="warn" text="{{shiftDesc | async}} is closed." closable="false"></p-message>
        <button
          pButton
          class="p-button-secondary"
          style="margin-left: 10px"
          label="Reopen&nbsp;Shift"
          [disabled]="reopeningShift"
          (click)="ReopenShift()">
        </button>
      </div>
      <div>
        <button *ngIf="(workedShift | async)"
          pButton
          class="p-button-danger"
          style="margin-left: 10px"
          label="Delete&nbsp;Shift"
          [icon]="deletingShift ? 'pi pi-spin pi-spinner' : 'pi pi-times'"
          [disabled]="((workedShiftStatus | async) !== ShiftStatus.Open) || deletingShift"
          (click)="DeleteShift()">
        </button>
      </div>
    </div>
  </p-toolbar>
</form>

<p-dialog
    header="Open New Shift for Inventory"
    [modal]="true"
    [(visible)]="showOpenDialog">
  <p>
    {{shiftDesc | async}}
    is not currently open for site
    {{ siteLabel | async }}
  </p>
  <p>Do you wish to open this day/shift for inventory?</p>
  <div class="centered">
    <button pButton
      label="Cancel"
      class="p-button-secondary"
      (click)="CloseOpenShiftDialog()"></button>
    <button pButton
      label="Open Shift"
      [icon]="openingShift ? 'pi pi-spin pi-spinner' : ''"
      [disabled]="openingShift"
      (click)="OpenNewShift()"></button>
  </div>
  </p-dialog>
<p-dialog
        header="Shift Cancel Failed"
        [modal]="true"
        [(visible)]="showDeleteValidationDialog">
  <validation-message
    [validationSummary]="workFlowValidationSummary">
  </validation-message>
</p-dialog>
